<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'none',
  data: function(){
    return {
      defaultLayout: 'none',
    }
  },
}
</script>

<style lang="scss">

</style>
